<div class="class-reg-popup">
    <div class="text-center succsess-register-box">
 
      <h4>Your payment has already been captured. Please visit ‘My Subscriptions’ to download the invoice.</h4>
     
      <button class="btn   UNFAPP-blue-txt-link" type="button" data-dismiss="modal" (click)=" close()" [routerLink] ="['/dashboard/subscribedPackages']">My Subscriptions</button>
    </div>
  </div>